import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mb-15" }
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = {
  key: 0,
  class: "overlay"
}
const _hoisted_4 = { class: "d-flex mb-4" }
const _hoisted_5 = { class: "tabs-container" }
const _hoisted_6 = { class: "context-menu" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "d-flex mb-4" }
const _hoisted_9 = { class: "panel-header panel-left" }
const _hoisted_10 = { style: {"user-select":"none"} }
const _hoisted_11 = { style: {"height":"50px","width":"340px","border":"solid 4px #f0f0f0"} }
const _hoisted_12 = {
  key: 0,
  class: "replacement-heading-box"
}
const _hoisted_13 = {
  class: "panel-left",
  ref: "staffTabLeftPanel"
}
const _hoisted_14 = { class: "schedule-col name schedule-body-cell" }
const _hoisted_15 = {
  class: "panel-header panel-center",
  style: `width: ${24 * 200}px; user-select: none;`
}
const _hoisted_16 = { class: "hour-col" }
const _hoisted_17 = { class: "min-cols" }
const _hoisted_18 = { class: "minute-box minute-label" }
const _hoisted_19 = {
  key: 0,
  class: "minute-box replacement-label"
}
const _hoisted_20 = {
  key: 1,
  class: "minute-box replacement-label"
}
const _hoisted_21 = {
  key: 2,
  class: "minute-box replacement-label"
}
const _hoisted_22 = {
  key: 3,
  class: "minute-box replacement-label -secondary"
}
const _hoisted_23 = {
  key: 4,
  class: "minute-box replacement-label -secondary"
}
const _hoisted_24 = {
  key: 5,
  class: "minute-box replacement-label -secondary"
}
const _hoisted_25 = {
  key: 6,
  class: "minute-box replacement-label -tertiary"
}
const _hoisted_26 = {
  key: 7,
  class: "minute-box replacement-label -tertiary"
}
const _hoisted_27 = {
  key: 8,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_28 = {
  key: 9,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_29 = {
  key: 10,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_30 = {
  key: 11,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_31 = {
  key: 12,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_32 = {
  class: "panel-center",
  ref: "staffTabCenterPanel"
}
const _hoisted_33 = ["onMousedown", "onMousemove", "onMouseup"]
const _hoisted_34 = {
  key: 2,
  style: `background-color: #fdd35c; height: 10px; border: 1px solid #FFFFFF; margin-top: 2px;`,
  class: "body-cell-minute-content"
}
const _hoisted_35 = { class: "d-flex mb-4" }
const _hoisted_36 = { class: "d-flex mb-4" }
const _hoisted_37 = { class: "panel-header panel-left" }
const _hoisted_38 = { style: {"user-select":"none"} }
const _hoisted_39 = { style: {"height":"50px","width":"340px","border":"solid 4px #f0f0f0"} }
const _hoisted_40 = {
  key: 0,
  class: "replacement-heading-box"
}
const _hoisted_41 = {
  class: "panel-left",
  ref: "childTabLeftPanel"
}
const _hoisted_42 = { class: "schedule-col name schedule-body-cell schedule-name-cell--with-action" }
const _hoisted_43 = { class: "schedule-name-text" }
const _hoisted_44 = {
  class: "panel-header panel-center",
  style: `width: ${24 * 200}px;`
}
const _hoisted_45 = { class: "hour-col" }
const _hoisted_46 = { class: "min-cols" }
const _hoisted_47 = { class: "minute-box minute-label" }
const _hoisted_48 = {
  key: 0,
  class: "minute-box replacement-label"
}
const _hoisted_49 = {
  key: 1,
  class: "minute-box replacement-label"
}
const _hoisted_50 = {
  key: 2,
  class: "minute-box replacement-label"
}
const _hoisted_51 = {
  key: 3,
  class: "minute-box replacement-label -secondary"
}
const _hoisted_52 = {
  key: 4,
  class: "minute-box replacement-label -secondary"
}
const _hoisted_53 = {
  key: 5,
  class: "minute-box replacement-label -secondary"
}
const _hoisted_54 = {
  key: 6,
  class: "minute-box replacement-label -tertiary"
}
const _hoisted_55 = {
  key: 7,
  class: "minute-box replacement-label -tertiary"
}
const _hoisted_56 = {
  key: 8,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_57 = {
  key: 9,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_58 = {
  key: 10,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_59 = {
  key: 11,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_60 = {
  key: 12,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_61 = {
  class: "panel-center",
  ref: "childTabCenterPanel"
}
const _hoisted_62 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"background-color":"grey","height":"30px"}
}
const _hoisted_63 = { key: 1 }
const _hoisted_64 = {
  key: 0,
  style: `background-color: #029ec0; height: 30px;`,
  class: "body-cell-minute-content"
}
const _hoisted_65 = {
  key: 1,
  style: `background-color: #fdd35c; height: 10px; border: 1px solid #FFFFFF; margin-top: 2px;`,
  class: "body-cell-minute-content"
}
const _hoisted_66 = { class: "d-flex mb-4" }
const _hoisted_67 = { class: "d-flex mb-4" }
const _hoisted_68 = { class: "panel-header panel-left" }
const _hoisted_69 = { style: {"user-select":"none"} }
const _hoisted_70 = { style: {"height":"50px","width":"340px","border":"solid 4px #f0f0f0"} }
const _hoisted_71 = {
  key: 0,
  class: "replacement-heading-box"
}
const _hoisted_72 = { class: "panel-left" }
const _hoisted_73 = { style: {"height":"24px","background-color":"#F8F5F5"} }
const _hoisted_74 = { class: "schedule-col name schedule-body-cell" }
const _hoisted_75 = { style: {"height":"24px","background-color":"#F8F5F5"} }
const _hoisted_76 = { class: "schedule-col name schedule-body-cell schedule-name-cell--with-action" }
const _hoisted_77 = { class: "schedule-name-text" }
const _hoisted_78 = {
  class: "panel-header panel-center",
  style: `width: ${24 * 200}px; user-select: none;`
}
const _hoisted_79 = { class: "hour-col" }
const _hoisted_80 = { class: "min-cols" }
const _hoisted_81 = { class: "minute-box minute-label" }
const _hoisted_82 = {
  key: 0,
  class: "minute-box replacement-label"
}
const _hoisted_83 = {
  key: 1,
  class: "minute-box replacement-label"
}
const _hoisted_84 = {
  key: 2,
  class: "minute-box replacement-label"
}
const _hoisted_85 = {
  key: 3,
  class: "minute-box replacement-label -secondary"
}
const _hoisted_86 = {
  key: 4,
  class: "minute-box replacement-label -secondary"
}
const _hoisted_87 = {
  key: 5,
  class: "minute-box replacement-label -secondary"
}
const _hoisted_88 = {
  key: 6,
  class: "minute-box replacement-label -tertiary"
}
const _hoisted_89 = {
  key: 7,
  class: "minute-box replacement-label -tertiary"
}
const _hoisted_90 = {
  key: 8,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_91 = {
  key: 9,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_92 = {
  key: 10,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_93 = {
  key: 11,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_94 = {
  key: 12,
  class: "minute-box replacement-label -quaternary"
}
const _hoisted_95 = { class: "panel-center" }
const _hoisted_96 = ["onMousedown", "onMousemove", "onMouseup"]
const _hoisted_97 = {
  key: 2,
  style: `background-color: #fdd35c; height: 10px; border: 1px solid #FFFFFF; margin-top: 2px;`,
  class: "body-cell-minute-content"
}
const _hoisted_98 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"background-color":"grey","height":"30px"}
}
const _hoisted_99 = { key: 1 }
const _hoisted_100 = {
  key: 0,
  style: `background-color: #029ec0; height: 30px;`,
  class: "body-cell-minute-content"
}
const _hoisted_101 = {
  key: 1,
  style: `background-color: #fdd35c; height: 10px; border: 1px solid #FFFFFF; margin-top: 2px;`,
  class: "body-cell-minute-content"
}
const _hoisted_102 = { class: "mb-4" }
const _hoisted_103 = { class: "mb-4" }
const _hoisted_104 = { class: "mb-4" }
const _hoisted_105 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_106 = {
  key: 0,
  class: "my-2"
}
const _hoisted_107 = { style: {"display":"flex","align-items":"center","justify-content":"center"} }
const _hoisted_108 = { class: "modal-content" }
const _hoisted_109 = {
  class: "d-flex align-center justify-center mb-2",
  style: {"position":"relative"}
}
const _hoisted_110 = { class: "text-center ma-0" }
const _hoisted_111 = { class: "checklist" }
const _hoisted_112 = { class: "modal-footer text-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_pager = _resolveComponent("date-pager")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_scrollable_panels = _resolveComponent("scrollable-panels")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_hour_minute_input = _resolveComponent("hour-minute-input")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_date_pager, {
        modelValue: _ctx.yearMonthDate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.yearMonthDate) = $event))
      }, null, 8, ["modelValue"])
    ]),
    (_ctx.isOverlayVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _ctx.downloadShiftPattern,
        color: "primary",
        variant: "outlined",
        disabled: _ctx.isFetching,
        class: "mr-8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode("mdi-tray-arrow-down", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.daily.downloadDaily')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"]),
      _createVNode(_component_v_btn, {
        onClick: _ctx.downloadMonthlyShiftPattern,
        color: "primary",
        variant: "outlined",
        disabled: _ctx.isFetching
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createTextVNode("mdi-tray-arrow-down", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.daily.downloadMonthly')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 1,
          indeterminate: "",
          color: "primary",
          class: "my-4"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_tabs, {
          modelValue: _ctx.currentTab,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentTab) = $event)),
          color: "primary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tab, {
              value: 0,
              class: "custom-tab"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.daily.staffTab')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_tab, {
              value: 1,
              class: "custom-tab"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.daily.childTab')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_tab, {
              value: 2,
              class: "custom-tab"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.daily.combinedTab')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    (_ctx.showMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          style: _normalizeStyle({ position: 'absolute', left: `${_ctx.menuPosition.x}px`, top: `${_ctx.menuPosition.y}px`, zIndex: 120})
        }, [
          _createElementVNode("ul", _hoisted_6, [
            _cache[26] || (_cache[26] = _createElementVNode("div", { style: {"height":"12px"} }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contextMenuOptions, (option) => {
              return (_openBlock(), _createElementBlock("li", {
                key: option.value,
                onClick: ($event: any) => (_ctx.handleMenuSelect(option.value))
              }, _toDisplayString(option.labelKey ? _ctx.$t(option.labelKey) : option.label), 9, _hoisted_7))
            }), 128))
          ]),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args))),
            style: {"position":"absolute","top":"2px","right":"6px"}
          }, [...(_cache[27] || (_cache[27] = [
            _createElementVNode("strong", null, "×", -1)
          ]))])
        ], 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_v_window, {
        modelValue: _ctx.currentTab,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentTab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.openUpdatePlacement,
                  color: "primary",
                  variant: "outlined",
                  disabled: _ctx.isFetching
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.daily.updatePlacement')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _createVNode(_component_scrollable_panels, {
                "initial-scroll-x": 1400,
                leftWidth: 340
              }, {
                "left-panel-header": _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          block: "",
                          variant: "text",
                          color: "black",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openDisplaySettings())),
                          style: {"height":"50px"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                  _createTextVNode("mdi-cog", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.daily.displaySettings')), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.translatedAvailableItems, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item.id
                        }, [
                          (_ctx.selectedDisplayItems.includes(item.id))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["replacement-label bold", { 
                          '-secondary': item.type === 'secondary',
                          '-tertiary': item.type === 'tertiary',
                          '-quaternary': item.type === 'quaternary'
                        }])
                                }, _toDisplayString(item.label), 3)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ])
                ]),
                "left-panel-body": _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleTableRows, (schedule, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "schedule-row",
                        key: `row-${i}`
                      }, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(schedule.name), 1)
                      ]))
                    }), 128))
                  ], 512), [
                    [_vShow, !_ctx.loading]
                  ])
                ]),
                "center-panel-header": _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableCols, (hourItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "header-col",
                        key: hourItem.hour,
                        style: _normalizeStyle(_ctx.dynamicHeightStyle)
                      }, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(hourItem.hour), 1),
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hourItem.items, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.minute,
                              class: "min-col",
                              style: _normalizeStyle(_ctx.dynamicHeightStyleSelection)
                            }, [
                              _createElementVNode("div", _hoisted_18, _toDisplayString(item.minute), 1),
                              (_ctx.selectedDisplayItems.includes(1))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(item.requisite ? item.requisite.govExpected : ''), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(2))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(item.requisite ? item.requisite.expected : ''), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(3))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item.sufficient ? item.sufficient.expected : ''), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(4))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(item.requisite && item.requisite.govActual !== null ? item.requisite.govActual : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(5))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(item.requisite && item.requisite.actual !== null ? item.requisite.actual : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(6))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(item.sufficient && item.sufficient.actual !== null ? item.sufficient.actual : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(7))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(item.sufficient && item.sufficient.expected !== null && item.requisite && item.requisite.expected !== null ? (item.sufficient.expected - item.requisite.expected) : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(8))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(item.sufficient && item.sufficient.actual !== null && item.requisite && item.requisite.actual !== null ? (item.sufficient.actual - item.requisite.actual) : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(9))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(item.attendance ? item.attendance.age0 : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(10))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(item.attendance ? item.attendance.age1 : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(11))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(item.attendance ? item.attendance.age2 : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(12))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(item.attendance ? item.attendance.age3 : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(13))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(item.attendance ? item.attendance.age4 : '-'), 1))
                                : _createCommentVNode("", true)
                            ], 4))
                          }), 128))
                        ])
                      ], 4))
                    }), 128))
                  ])
                ]),
                "center-panel-body": _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleTableRows, (row, i) => {
                      return _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "schedule-row",
                        style: { width: `${24 * 200}px` }
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.items, (item, j) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: j,
                            class: "body-cell-hour"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (minItem, k) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["body-cell-minute", {
                          'body-cell-removing': minItem.isFilled || _ctx.isFillCell,
                          'body-cell-drawing': !minItem.isFilled,
                          'body-cell-error-drawing': _ctx.isDrawingErorr
                        }]),
                                key: k,
                                onMousedown: ($event: any) => (_ctx.startSelection(minItem.isFilled, i, j, k, minItem.tableID, row.userId)),
                                onMousemove: ($event: any) => (_ctx.selectRange(row.userId, minItem.isFilled, i, j, k, minItem.tableID)),
                                onMouseup: ($event: any) => (_ctx.endSelection(row.userId, minItem.isFilled, $event, i, j, k))
                              }, [
                                (minItem.isFilled)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      style: _normalizeStyle(`background-color: ${minItem.color}; height: 30px; color: ${minItem.fontColor};`),
                                      class: _normalizeClass(["body-cell-minute-content", _ctx.getCellClass(minItem.isFilled, i, j, k)])
                                    }, _toDisplayString(minItem.abbreviation), 7))
                                  : _createCommentVNode("", true),
                                (!minItem.isFilled)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      style: `height: 30px;`,
                                      class: _normalizeClass(["body-cell-minute-content", _ctx.getCellClass(minItem.isFilled, i, j, k)])
                                    }, null, 2))
                                  : _createCommentVNode("", true),
                                (minItem.inSchool)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34))
                                  : _createCommentVNode("", true)
                              ], 42, _hoisted_33))
                            }), 128))
                          ]))
                        }), 128))
                      ])), [
                        [_vShow, !_ctx.loading]
                      ])
                    }), 128))
                  ], 512), [
                    [_vShow, !_ctx.loading]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 1 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_select, {
                  variant: "filled",
                  label: _ctx.$t('workScheduling.daily.classLabel'),
                  density: "compact",
                  items: _ctx.classes,
                  "item-title": "className",
                  "item-value": "classId",
                  modelValue: _ctx.selectedClassId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedClassId) = $event)),
                  style: {"width":"100px"}
                }, null, 8, ["label", "items", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.openUpdatePlacement,
                  color: "primary",
                  variant: "outlined",
                  disabled: _ctx.isFetching
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.daily.updatePlacement')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_scrollable_panels, {
                  "initial-scroll-x": 1400,
                  leftWidth: 340
                }, {
                  "left-panel-header": _withCtx(() => [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_v_btn, {
                            size: "small",
                            block: "",
                            variant: "text",
                            color: "black",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openDisplaySettings())),
                            style: {"height":"50px"}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                    _createTextVNode("mdi-cog", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.daily.displaySettings')), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.translatedAvailableItems, (item) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: item.id
                          }, [
                            (_ctx.selectedDisplayItems.includes(item.id))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["replacement-label bold", { 
                              '-secondary': item.type === 'secondary',
                              '-tertiary': item.type === 'tertiary',
                              '-quaternary': item.type === 'quaternary'
                            }])
                                  }, _toDisplayString(item.label), 3)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ])
                    ])
                  ]),
                  "left-panel-body": _withCtx(() => [
                    _createElementVNode("div", _hoisted_41, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childScheduleTableRows, (schedule, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "schedule-row",
                          key: `row-${i}`
                        }, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("span", _hoisted_43, _toDisplayString(schedule.name), 1),
                            _createVNode(_component_v_btn, {
                              color: "primary",
                              variant: "flat",
                              size: "small",
                              class: "schedule-name-edit-btn",
                              onClick: ($event: any) => (_ctx.openEditScheduleModal(schedule.child, schedule.schedules))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.daily.edit')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ], 512)
                  ]),
                  "center-panel-header": _withCtx(() => [
                    _createElementVNode("div", _hoisted_44, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableCols, (hourItem) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "header-col",
                          key: hourItem.hour,
                          style: _normalizeStyle(_ctx.dynamicHeightStyle)
                        }, [
                          _createElementVNode("div", _hoisted_45, _toDisplayString(hourItem.hour), 1),
                          _createElementVNode("div", _hoisted_46, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hourItem.items, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.minute,
                                class: "min-col",
                                style: _normalizeStyle(_ctx.dynamicHeightStyleSelection)
                              }, [
                                _createElementVNode("div", _hoisted_47, _toDisplayString(item.minute), 1),
                                (_ctx.selectedDisplayItems.includes(1))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(item.requisite ? item.requisite.govExpected : ''), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedDisplayItems.includes(2))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(item.requisite ? item.requisite.expected : ''), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedDisplayItems.includes(3))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(item.sufficient ? item.sufficient.expected : ''), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedDisplayItems.includes(4))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(item.requisite && item.requisite.govActual !== null ? item.requisite.govActual : '-'), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedDisplayItems.includes(5))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(item.requisite && item.requisite.actual !== null ? item.requisite.actual : '-'), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedDisplayItems.includes(6))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(item.sufficient && item.sufficient.actual !== null ? item.sufficient.actual : '-'), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedDisplayItems.includes(7))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(item.sufficient && item.sufficient.expected !== null && item.requisite && item.requisite.expected !== null ? (item.sufficient.expected - item.requisite.expected) : '-'), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedDisplayItems.includes(8))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(item.sufficient && item.sufficient.actual !== null && item.requisite && item.requisite.actual !== null ? (item.sufficient.actual - item.requisite.actual) : '-'), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedDisplayItems.includes(9))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(item.attendance ? item.attendance.age0 : '-'), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedDisplayItems.includes(10))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(item.attendance ? item.attendance.age1 : '-'), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedDisplayItems.includes(11))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(item.attendance ? item.attendance.age2 : '-'), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedDisplayItems.includes(12))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(item.attendance ? item.attendance.age3 : '-'), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedDisplayItems.includes(13))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(item.attendance ? item.attendance.age4 : '-'), 1))
                                  : _createCommentVNode("", true)
                              ], 4))
                            }), 128))
                          ])
                        ], 4))
                      }), 128))
                    ])
                  ]),
                  "center-panel-body": _withCtx(() => [
                    _createElementVNode("div", _hoisted_61, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childScheduleTableRows, (schedule, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `row-${i}`,
                          class: "schedule-row",
                          style: { width: `${24 * 200}px` }
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (item, j) => {
                            return _createElementVNode("div", {
                              key: j,
                              class: "body-cell-hour"
                            }, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (minItem, k) => {
                                return _createElementVNode("div", {
                                  class: "body-cell-minute",
                                  key: k
                                }, [
                                  (schedule.schedules[0].status == 'isAbsent')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.$t('workScheduling.daily.statusIndicators.absent')), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                        (j*60 + k*15 >= schedule.schedules[0].startMin && j*60 + k*15 < schedule.schedules[0].endMin)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(_ctx.$t('workScheduling.daily.statusIndicators.present')), 1))
                                          : _createCommentVNode("", true),
                                        (_ctx.attendances && _ctx.attendances.attendances && _ctx.attendances.attendances[i] && _ctx.attendances.attendances[i].attendedAt && _ctx.attendances.attendances[i].leftAt
                            && j * 60 + k * 15 >= _ctx.formatHour(_ctx.attendances.attendances[i].attendedAt) * 60 + _ctx.formatMin(_ctx.attendances.attendances[i].attendedAt) 
                            && j * 60 + k * 15 < _ctx.formatHour(_ctx.attendances.attendances[i].leftAt) * 60 + _ctx.formatMin(_ctx.attendances.attendances[i].leftAt))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_65))
                                          : _createCommentVNode("", true)
                                      ]))
                                ])
                              }), 64))
                            ])
                          }), 64))
                        ]))
                      }), 128))
                    ], 512)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 2 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_66, [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_select, {
                  variant: "filled",
                  label: _ctx.$t('workScheduling.daily.classLabel'),
                  density: "compact",
                  items: _ctx.classes,
                  "item-title": "className",
                  "item-value": "classId",
                  modelValue: _ctx.selectedClassId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedClassId) = $event)),
                  style: {"width":"100px"}
                }, null, 8, ["label", "items", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.openUpdatePlacement,
                  color: "primary",
                  variant: "outlined",
                  disabled: _ctx.isFetching
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.daily.updatePlacement')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _createVNode(_component_scrollable_panels, {
                "initial-scroll-x": 1400,
                leftWidth: 340
              }, {
                "left-panel-header": _withCtx(() => [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          block: "",
                          variant: "text",
                          color: "black",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openDisplaySettings())),
                          style: {"height":"50px"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                  _createTextVNode("mdi-cog", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.daily.displaySettings')), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.translatedAvailableItems, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item.id
                        }, [
                          (_ctx.selectedDisplayItems.includes(item.id))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["replacement-label bold", { 
                            '-secondary': item.type === 'secondary',
                            '-tertiary': item.type === 'tertiary',
                            '-quaternary': item.type === 'quaternary'
                          }])
                                }, _toDisplayString(item.label), 3)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ])
                ]),
                "left-panel-body": _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$t('workScheduling.daily.staffLabel')), 1),
                    _createElementVNode("div", {
                      class: "staff-table",
                      ref: "StaffleftPanel",
                      onScroll: _cache[8] || (_cache[8] = ($event: any) => (_ctx.syncScroll('staffleft'))),
                      style: {"overflow-y":"auto","max-height":"420px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleTableRows, (schedule, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "schedule-row",
                          key: `row-${i}`
                        }, [
                          _createElementVNode("div", _hoisted_74, _toDisplayString(schedule.name), 1)
                        ]))
                      }), 128))
                    ], 544),
                    _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.$t('workScheduling.daily.childLabel')), 1),
                    _createElementVNode("div", {
                      class: "child-table",
                      ref: "ChildleftPanel",
                      onScroll: _cache[9] || (_cache[9] = ($event: any) => (_ctx.syncScroll('childleft'))),
                      style: {"overflow-y":"auto","max-height":"600px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childScheduleTableRows, (schedule, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "schedule-row",
                          key: `row-${i}`
                        }, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("span", _hoisted_77, _toDisplayString(schedule.name), 1),
                            _createVNode(_component_v_btn, {
                              color: "primary",
                              variant: "flat",
                              size: "small",
                              class: "schedule-name-edit-btn",
                              onClick: ($event: any) => (_ctx.openEditScheduleModal(schedule.child, schedule.schedules))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.daily.edit')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ], 544)
                  ], 512), [
                    [_vShow, !_ctx.loading]
                  ])
                ]),
                "center-panel-header": _withCtx(() => [
                  _createElementVNode("div", _hoisted_78, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableCols, (hourItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "header-col",
                        key: hourItem.hour,
                        style: _normalizeStyle(_ctx.dynamicHeightStyle)
                      }, [
                        _createElementVNode("div", _hoisted_79, _toDisplayString(hourItem.hour), 1),
                        _createElementVNode("div", _hoisted_80, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hourItem.items, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.minute,
                              class: "min-col",
                              style: _normalizeStyle(_ctx.dynamicHeightStyleSelection)
                            }, [
                              _createElementVNode("div", _hoisted_81, _toDisplayString(item.minute), 1),
                              (_ctx.selectedDisplayItems.includes(1))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, _toDisplayString(item.requisite ? item.requisite.govExpected : ''), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(2))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString(item.requisite ? item.requisite.expected : ''), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(3))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(item.sufficient ? item.sufficient.expected : ''), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(4))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(item.requisite && item.requisite.govActual !== null ? item.requisite.govActual : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(5))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(item.requisite && item.requisite.actual !== null ? item.requisite.actual : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(6))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_87, _toDisplayString(item.sufficient && item.sufficient.actual !== null ? item.sufficient.actual : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(7))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(item.sufficient && item.sufficient.expected !== null && item.requisite && item.requisite.expected !== null ? (item.sufficient.expected - item.requisite.expected) : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(8))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString(item.sufficient && item.sufficient.actual !== null && item.requisite && item.requisite.actual !== null ? (item.sufficient.actual - item.requisite.actual) : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(9))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(item.attendance ? item.attendance.age0 : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(10))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(item.attendance ? item.attendance.age1 : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(11))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString(item.attendance ? item.attendance.age2 : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(12))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(item.attendance ? item.attendance.age3 : '-'), 1))
                                : _createCommentVNode("", true),
                              (_ctx.selectedDisplayItems.includes(13))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(item.attendance ? item.attendance.age4 : '-'), 1))
                                : _createCommentVNode("", true)
                            ], 4))
                          }), 128))
                        ])
                      ], 4))
                    }), 128))
                  ])
                ]),
                "center-panel-body": _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_95, [
                    _cache[31] || (_cache[31] = _createElementVNode("div", { style: {"height":"24px","background-color":"#F8F5F5"} }, null, -1)),
                    _createElementVNode("div", {
                      class: "staff-table",
                      ref: "StaffcenterPanel",
                      onScroll: _cache[10] || (_cache[10] = ($event: any) => (_ctx.syncScroll('staffcenter'))),
                      style: {"overflow-y":"auto","max-height":"420px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleTableRows, (row, i) => {
                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "schedule-row",
                          style: { width: `${24 * 200}px` }
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.items, (item, j) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: j,
                              class: "body-cell-hour"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (minItem, k) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(["body-cell-minute", {
                          'body-cell-removing': minItem.isFilled || _ctx.isFillCell,
                          'body-cell-drawing': !minItem.isFilled,
                          'body-cell-error-drawing': _ctx.isDrawingErorr
                        }]),
                                  key: k,
                                  onMousedown: ($event: any) => (_ctx.startSelection(minItem.isFilled, i, j, k, minItem.tableID, row.userId)),
                                  onMousemove: ($event: any) => (_ctx.selectRange(row.userId, minItem.isFilled, i, j, k, minItem.tableID)),
                                  onMouseup: ($event: any) => (_ctx.endSelection(row.userId, minItem.isFilled, $event, i, j, k))
                                }, [
                                  (minItem.isFilled)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        style: _normalizeStyle(`background-color: ${minItem.color}; height: 30px; color: ${minItem.fontColor};`),
                                        class: _normalizeClass(["body-cell-minute-content", _ctx.getCellClass(minItem.isFilled, i, j, k)])
                                      }, _toDisplayString(minItem.abbreviation), 7))
                                    : _createCommentVNode("", true),
                                  (!minItem.isFilled)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        style: `height: 30px;`,
                                        class: _normalizeClass(["body-cell-minute-content", _ctx.getCellClass(minItem.isFilled, i, j, k)])
                                      }, null, 2))
                                    : _createCommentVNode("", true),
                                  (minItem.inSchool)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97))
                                    : _createCommentVNode("", true)
                                ], 42, _hoisted_96))
                              }), 128))
                            ]))
                          }), 128))
                        ])), [
                          [_vShow, !_ctx.loading]
                        ])
                      }), 128))
                    ], 544),
                    _cache[32] || (_cache[32] = _createElementVNode("div", { style: {"height":"24px","background-color":"#F8F5F5"} }, null, -1)),
                    _createElementVNode("div", {
                      class: "child-table",
                      ref: "ChildcenterPanel",
                      onScroll: _cache[11] || (_cache[11] = ($event: any) => (_ctx.syncScroll('childcenter'))),
                      style: {"overflow-y":"auto","max-height":"600px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childScheduleTableRows, (schedule, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `row-${i}`,
                          class: "schedule-row",
                          style: { width: `${24 * 200}px` }
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (item, j) => {
                            return _createElementVNode("div", {
                              key: j,
                              class: "body-cell-hour"
                            }, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (minItem, k) => {
                                return _createElementVNode("div", {
                                  class: "body-cell-minute",
                                  key: k
                                }, [
                                  (schedule.schedules[0].status == 'isAbsent')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, _toDisplayString(_ctx.$t('workScheduling.daily.statusIndicators.absent')), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                        (j*60 + k*15 >= schedule.schedules[0].startMin && j*60 + k*15 < schedule.schedules[0].endMin)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(_ctx.$t('workScheduling.daily.statusIndicators.present')), 1))
                                          : _createCommentVNode("", true),
                                        (_ctx.attendances && _ctx.attendances.attendances && _ctx.attendances.attendances[i] && _ctx.attendances.attendances[i].attendedAt && _ctx.attendances.attendances[i].leftAt
                            && j * 60 + k * 15 >= _ctx.formatHour(_ctx.attendances.attendances[i].attendedAt) * 60 + _ctx.formatMin(_ctx.attendances.attendances[i].attendedAt) 
                            && j * 60 + k * 15 < _ctx.formatHour(_ctx.attendances.attendances[i].leftAt) * 60 + _ctx.formatMin(_ctx.attendances.attendances[i].leftAt))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_101))
                                          : _createCommentVNode("", true)
                                      ]))
                                ])
                              }), 64))
                            ])
                          }), 64))
                        ]))
                      }), 128))
                    ], 544)
                  ], 512), [
                    [_vShow, !_ctx.loading]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_v_overlay, {
      modelValue: _ctx.loading,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.loading) = $event)),
      class: "align-center justify-center",
      persistent: "",
      "z-index": "5000"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          height: "200",
          width: "200",
          class: "d-flex align-center justify-center",
          rounded: "lg",
          elevation: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              color: "primary",
              indeterminate: "",
              size: 150
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.daily.processing')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "1080px",
      modelValue: _ctx.isEditScheduleModalOpen,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.isEditScheduleModalOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.editingChildSchedule && _ctx.editingChild)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.daily.childScheduleModalTitle')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "mb-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_102, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('children.childName')), 1),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.editingChild.lastName) + " " + _toDisplayString(_ctx.editingChild.firstName), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_103, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('common.date')), 1),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.formatDisplayDate(_ctx.editingChildSchedule[0].date)), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { class: "mb-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_104, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('workScheduling.daily.attendanceStatus')), 1),
                              _createVNode(_component_v_select, {
                                variant: "outlined",
                                density: "compact",
                                items: _ctx.absenseOptions,
                                "item-title": "title",
                                "item-value": "value",
                                modelValue: _ctx.editingChildSchedule[0].status,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editingChildSchedule[0].status) = $event)),
                                color: "primary"
                              }, null, 8, ["items", "modelValue"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col)
                      ]),
                      _: 1
                    }),
                    (_ctx.editingChildSchedule[0].status === 'isAbsent')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('workScheduling.daily.absenceReason')), 1),
                          _createVNode(_component_v_select, {
                            variant: "outlined",
                            density: "compact",
                            items: _ctx.absenseReasons,
                            "item-title": "title",
                            "item-value": "value",
                            modelValue: _ctx.editingChildSchedule[0].statusReason,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editingChildSchedule[0].statusReason) = $event)),
                            color: "primary"
                          }, null, 8, ["items", "modelValue"]),
                          (_ctx.editingChildSchedule[0].statusReason === 'others')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                _createVNode(_component_v_textarea, {
                                  variant: "outlined",
                                  label: _ctx.$t('workScheduling.daily.commentRequired'),
                                  modelValue: _ctx.editingChildSchedule[0].statusComment,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editingChildSchedule[0].statusComment) = $event)),
                                  color: "primary"
                                }, null, 8, ["label", "modelValue"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.editingChildSchedule[0].status === 'attending')
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 1,
                          class: "mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('workScheduling.daily.checkInTime')), 1),
                                _createVNode(_component_hour_minute_input, {
                                  modelValue: _ctx.editingChildSchedule[0].startMin,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editingChildSchedule[0].startMin) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('workScheduling.daily.checkOutTime')), 1),
                                _createVNode(_component_hour_minute_input, {
                                  modelValue: _ctx.editingChildSchedule[0].endMin,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.editingChildSchedule[0].endMin) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "red",
                      class: "mx-2",
                      onClick: _ctx.deleteEditingShcedule
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "primary",
                      class: "mx-2",
                      onClick: _ctx.saveEditingShcedule
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                (_ctx.isUpdatingSchedule)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "600px",
      modelValue: _ctx.isUpdatePlacement,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.isUpdatePlacement) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { style: {"align-items":"center","justify-content":"center","height":"180px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { style: {"display":"flex","align-items":"center","justify-content":"center"} }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { style: {"color":"red"} }, {
                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                    _createTextVNode("mdi-information-outline", -1)
                  ]))]),
                  _: 1
                }),
                _createTextVNode("  " + _toDisplayString(_ctx.$t('workScheduling.daily.placementCalcConfirm')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { style: {"display":"flex","align-items":"center","justify-content":"center","color":"black"} }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.daily.placementCalcNoteShort')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_107, [
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    color: "primary",
                    class: "mx-2",
                    onClick: _ctx.UpdateExpectedPlacement
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.daily.execute')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "600px",
      modelValue: _ctx.isCalcDialogOpen,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.isCalcDialogOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-4" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, [
                _createVNode(_component_v_checkbox, {
                  modelValue: _ctx.isDisplaySettingAllSelected,
                  "onUpdate:modelValue": [
                    _cache[21] || (_cache[21] = ($event: any) => ((_ctx.isDisplaySettingAllSelected) = $event)),
                    _ctx.toggleDisplaySettingAllSelection
                  ],
                  label: _ctx.$t('workScheduling.daily.selectAll'),
                  "hide-details": "",
                  density: "compact",
                  class: "mt-0 pt-0",
                  style: {"position":"absolute","left":"0"}
                }, null, 8, ["modelValue", "label", "onUpdate:modelValue"]),
                _createElementVNode("h2", _hoisted_110, _toDisplayString(_ctx.$t('workScheduling.daily.displaySettings')), 1)
              ]),
              _cache[35] || (_cache[35] = _createElementVNode("hr", null, null, -1)),
              _createElementVNode("div", _hoisted_111, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.translatedAvailableItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "checklist-item"
                  }, [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.selectedDisplayItemsTemp,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.selectedDisplayItemsTemp) = $event)),
                      value: item.id,
                      label: item.label,
                      color: "light-blue",
                      density: "compact"
                    }, null, 8, ["modelValue", "value", "label"]),
                    _cache[34] || (_cache[34] = _createElementVNode("hr", null, null, -1))
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_112, [
                _createVNode(_component_v_btn, {
                  onClick: _ctx.saveDisplaySettings,
                  class: "btn-primary",
                  color: "light-blue",
                  dark: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}